module.exports = __webpack_public_path__ + "img/9788980403196.a8c44f20.jpg";